// Interfaces
import { IFormCheckboxProps } from './interfaces'

// Antd
import { Checkbox } from 'antd'

// Lodash
import omit from 'lodash/omit'

const FormCheckbox = (props: IFormCheckboxProps) => {
  return <Checkbox {...omit(props, ['checkboxLabel'])}>{props.checkboxLabel}</Checkbox>
}

export { FormCheckbox }
